import { apolloClient } from '~/apollo-client';
import { CustomPlan } from '~/typings/context';
import {
  Flex_FetchExistingPlansQuery,
  Flex_FetchExistingPlansQueryVariables,
} from '~/typings/graphql';
import { FETCH_EXISTING_PLANS } from './fetch-existing-plans.queries';

export interface FetchExistingPlansParams {
  userId: number;
}

export interface FetchExistingPlansResponse {
  existingPlans: CustomPlan[];
}

export const fetchExistingPlans = async (
  params: FetchExistingPlansParams,
): Promise<FetchExistingPlansResponse> => {
  const { data } = await apolloClient.query<
    Flex_FetchExistingPlansQuery,
    Flex_FetchExistingPlansQueryVariables
  >({
    query: FETCH_EXISTING_PLANS,
    variables: { userId: params.userId },
  });

  const { accounts } = data.user;
  const existingPlans = accounts.map(a => a.customPlans).flat();
  return { existingPlans };
};
